import { documentFile, documentMaxBytes } from '../invoice-documents/files.ts';
export const damagePhotoMaxBytes = documentMaxBytes;
export type DamagePhoto = {
  id: string; report_id: number; state: 'pending' | 'stored' | 'voided'; name: string; caption: string;
  content_type: string; size: number; sha256: string; actor_name: string; created_at: string; stored_at: string | null;
  void_reason: string | null; void_actor_name: string | null; voided_at: string | null;
};
export type EarlierDamagePhoto = { index: number; name: string; problem: string | null };
export type DamagePhotoPage = { success: true; actor_id: string; report_id: number; photos: DamagePhoto[]; earlier: EarlierDamagePhoto[]; next: number | null };
export const damagePhotoId = (v: unknown): v is string => typeof v === 'string' && /^[a-f0-9]{64}$/.test(v);
export function damagePhotoBytes(data: string) {
  const binary = atob(data), bytes = new Uint8Array(binary.length);
  for (let n = 0; n < binary.length; n++) bytes[n] = binary.charCodeAt(n);
  return bytes;
}
export async function damagePhotoFile(bytes: Uint8Array, name: string) {
  const info = await documentFile(bytes, name);
  if (info.type === 'application/pdf') throw new Error('Choose a PNG, JPEG or WebP photo up to 10 MB.');
  return info;
}
export async function damagePhotoHash(value: unknown) {
  return [...new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(value))))].map(n => n.toString(16).padStart(2, '0')).join('');
}
export function photoRequestId(v: unknown): string {
  if (typeof v !== 'string' || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(v)) throw new Error('Use the original photo save reference.');
  return v;
}
export function photoText(v: unknown, required = false): string {
  if (v == null) v = '';
  if (typeof v !== 'string' || v.length > 500 || required && !v.trim()) throw new Error('Enter photo details up to 500 characters.');
  return v.trim();
}
